import { Coords } from './location-source.types';

/**
 * Decimal places to keep on a coordinate before it becomes a query key.
 *
 * The nearby-businesses query is keyed on the user's coordinates, so an
 * unrounded GPS fix changes the key on every metre of jitter and defeats the
 * persisted cache -- last session's result never matches this session's key.
 * Three decimals is ~110m: coarse enough that a returning user in the same spot
 * reuses the cached result, fine enough that a real move to a new area misses.
 */
const COORD_PRECISION_DECIMALS = 3;

const factor = 10 ** COORD_PRECISION_DECIMALS;

function roundTo(value: number): number {
  return Math.round(value * factor) / factor;
}

/**
 * Round a coordinate to a stable precision so it can serve as a cache key.
 * Returns a new object; the input is not mutated.
 */
export function roundCoords(coords: Coords): Coords {
  return {
    latitude: roundTo(coords.latitude),
    longitude: roundTo(coords.longitude),
  };
}
